import React, {useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import { useHistory, useParams} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FormCad } from '../components';
import Swal from 'sweetalert2';
import initialData from './initialData';
import schema from './schema';
import { storeQuestaoAnalise, loadQuestaoAnalises, changeStatus} from '~/store/modules/questao_analise/action';
const Create = () => {
  let history = useHistory();

  const {tipo_meio_analise_id} = useParams();

  const [ questaoAnalise, setQuestaoAnalise] = useState(initialData);

  const [errorsValidate, setErrorsValidate] = useState([]);
  const dispatch = useDispatch();
  const { status_response, errors } = useSelector(({ QuestaoAnaliseReducer }) => QuestaoAnaliseReducer);


  useEffect(() => {
    if (errors.status && errors.status === 422) {
      let server_errors = {};
      const response_errors = errors.data.errors;
      for (let name of Object.keys(response_errors)) {
        Object.assign(server_errors, { [name]: response_errors[name][0] });
      }
      setErrorsValidate(server_errors);
    }
  }, [errors]);


  useEffect(() => {
    if (status_response === 201) {
      Swal.fire('Sucesso', 'Registro salvo com sucesso!', 'success').then(
        () => {
          history.goBack();
          dispatch(loadQuestaoAnalises({
            where:`tipo_meio_analise_id:${tipo_meio_analise_id}`
          }));
          dispatch(changeStatus(null));
        }
      );
    }
  }, [status_response, history, dispatch, tipo_meio_analise_id]);


  const handleClose = () => {
    history.goBack();
  };

  const handleSubmit = async event => {
    event.preventDefault();

    if (!schema.isValidSync( questaoAnalise)) {
      // console.log('Error  questaoAnalise store: ', questaoAnalise);
      let yup_errors = {};
      schema.validate( questaoAnalise, { abortEarly: false }).catch(err => {
        for (let error of err.inner) {
          const { path, message } = error;
          Object.assign(yup_errors, { [path]: message });
        }
        setErrorsValidate(yup_errors);
      });
    } else {
      const questaoAnalise_ =  questaoAnalise;
      questaoAnalise_.tipo_meio_analise_id = parseInt(tipo_meio_analise_id);
      await dispatch(storeQuestaoAnalise(questaoAnalise_));
    }
  };

  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="modal-xl"
      onHide={handleClose}
      show
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
         Questão
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Novo</h2>
          </div>
          <div className="card-body">
            <FormCad
              errors={errorsValidate}
              handleSubmit={handleSubmit}
              questaoAnalise={questaoAnalise}
              schema={schema}
              setQuestaoAnalise={setQuestaoAnalise}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-default"
          onClick={handleClose}
        >
          <i className="fa fa-window-close" /> Cancelar
        </button>
        <button
          className="btn btn-success"
          form="form_questaoAnalise"
          type="submint"
        >
          {' '}
          <i className="fa fa-save" /> Salvar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default Create;

